import { Component, Input } from "@angular/core";
import isElectron from "is-electron";

import { CanvasComponent } from "./canvas.component";
import { InputComponent } from "./input.component";

import { LanguageService } from "../services/language.service";
import { EditorContentService } from "../services/editorcontent.service";
import { CanvasService } from "../services/canvas.service";
import { QuickStartService } from "../services/quickstart.service";
import { LoginService } from "app/services/login.service";
import { SessionStorageService } from "../services/sessionstorage.service";
import { StorageService } from "app/services/onlinestorage.service";
import { DebuggerService } from "app/services/debugger.service";
import { ExamService } from "app/services/exam.service";
import { BlocksService } from "../services/blocks.service";
import { BluetoothService } from "../services/bluetooth.service";
import { RootService } from "app/services/root.service";
import { GridService } from "../services/grid.service";
import { TeacherToolService } from "../services/teachertool.service";

import * as $ from "jquery";
import { SpeedCalculatorService } from "app/services/speedcalculator.service";
import { CommandsService } from "app/services/commands.service";
import { InterpreterService } from "app/services/interpreter.service";

declare var require: (...any) => any;
declare var exerciseData: any;
declare var swal: any;
const sha256 = require("sha256");

@Component({
  selector: "header-component",
  templateUrl: "./header.component.html"
})
export class HeaderComponent {
  // Variables related to the icons
  private iconVariable = "app/img/countryIcons/english.png";
  private iconTurtleVariable = "app/img/turtles/turtle0.png";
  private navigationFullScreen = "app/img/navigation/enterfullscreen.gif";
  private stopButton = "app/img/navigation/stop.png";
  private userStatus = "app/img/navigation/logged_out.png";

  // Online or offline mode
  private runOffline = false;
  private quickstartService;

  //automatic saving on or off
  private automaticsavingText;

  // static reference
  public static headerComponent: HeaderComponent;

  // Cheat sheet
  private readonly CHEAT_SHEET_URL_DE = "https://xlogo.inf.ethz.ch/Cheatsheet.pdf";
  private readonly CHEAT_SHEET_URL_FR = "https://xlogo.inf.ethz.ch/Cheatsheet_FR.pdf";
  private readonly CHEAT_SHEET_URL_STAGE1_DE = "https://xlogo.inf.ethz.ch/Cheatsheet_Stage1.pdf";

  constructor(
    private la: LanguageService,
    private et: EditorContentService,
    private sessionstorage: SessionStorageService,
    private loginService: LoginService,
    private canvasService: CanvasService,
    private debuggerService: DebuggerService,
    private storageService: StorageService,
    private examService: ExamService,
    private blocks: BlocksService,
    private bluetoothService: BluetoothService,
    private rootService: RootService,
    private gridService: GridService,
    private teacherToolService: TeacherToolService,
    private speedcalculator: SpeedCalculatorService,
    private commandsService: CommandsService,
    private interpreterService: InterpreterService
  ) {
    HeaderComponent.headerComponent = this;

    (<any>window).setMat = this.setMat;

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event: MouseEvent) {
      // check whether dropdown menu was clicked or something else
      let el = <Element>event.target;
      //test whether headerbtn itself or its children were clicked (meaning any of the pictures)
      let selector = ".headerbtn, .headerbtn *";
      let p = Element.prototype;
      let f =
        p.matches ||
        p.webkitMatchesSelector ||
        function (s) {
          return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };

      // check whether dropdown menu was clicked or not
      let a = f.call(el, selector);

      // if it was not clicked, then close the dropdown menu
      if (!a) {
        let dropdowns = document.getElementsByClassName("dropdown-content");
        let i;
        for (i = 0; i < dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };

    //Override CTRL-S with custom save mechanism --> download editor
    window.addEventListener(
      "keydown",
      function (event) {
        if (
          (event.ctrlKey || event.metaKey) &&
          String.fromCharCode(event.which).toLowerCase() === "s"
        ) {
          event.preventDefault();
          if (!this.examService.examModeIsOn()) {
            this.saveFile();
          }
        }
      }.bind(this),
      false
    );
  }

  ngOnInit() {
    // set menu language icon accordingly
    switch (this.la.getLangAbbrev()) {
      case "de":
        this.iconVariable = "app/img/countryIcons/german.png";
        break;
      case "en":
        this.iconVariable = "app/img/countryIcons/english.png";
        break;
      case "it":
        this.iconVariable = "app/img/countryIcons/italian.png";
        break;
      case "fr":
        this.iconVariable = "app/img/countryIcons/french.png";
        break;
      case "es":
        this.iconVariable = "app/img/countryIcons/spanish.png";
        break;
      default:
    }

    // show promt to choose file on load file
    this.globalInputElement = <HTMLInputElement>document.createElement("INPUT");

    // load content of files on input file select
    this.globalInputElement.addEventListener(
      "change",
      function () {
        this.prepareEditor(this.globalInputElement);
      }.bind(this),
      false
    );
  }

  private globalInputElement: HTMLInputElement = null;

  loadFile() {
    this.prepareLoadFile(this.globalInputElement);
  }

  saveCanvas() {
    swal({
      title: this.la.translateKey("howtosave"),
      showCancelButton: true,
      confirmButtonText: this.la.translateKey("save-as-png"),
      cancelButtonText: this.la.translateKey("save-as-svg")
    })
      .then(result => {
        // PNG was chosen
        if (result) {
          this.canvasService.downloadAsPNG("canvas");
        }
      })
      .catch(async error => {
        // SVG was chosen, clicked on "cancel button"
        if (error === "cancel") {
          this.canvasService.downloadAsSVG("canvas");
        }
      });
  }

  exerciseMenu() {
    $("#createExerciseModal").hide();
    let chapterButtons = "";
    let chapter = this.la.getLang()["chapter"];
    let exercise = this.la.getLang()["exercise"];
    exerciseData.forEach(function (element, index) {
      let imgSource =
        '<img src="./app/img/chapters/chapter' + element.name + ".png" + '" />';
      chapterButtons +=
        '<button data-index="' +
        index +
        '" id="' +
        element.name +
        '" class = "chapterButton">' +
        chapter +
        element.name +
        imgSource +
        "</button>";
    });
    swal({
      title: this.la.getLang()["choose-exercise"],
      html: '<div class="alertButtonGroup">' + chapterButtons + "</div>",
      showCancelButton: false,
      confirmButtonText: this.la.getLang()["upload-exercise"],
      width: 800
    }).then(() => {
      // Upload option was chosen
      // Create new sweetalert with file input field
      swal({
        html:
          '</div><input type="file" accept="text/plain" id="fileInputField"><br>' +
          '<p id="divider"><span>' +
          this.la.getLang()["or"] +
          "</span></p>" +
          '<div id="keyInput">' +
          "<p>" +
          this.la.getLang()["key"] +
          ':</p><input type="text" id="keyInputField" maxlength="4">' +
          "</div>"
      }).then(() => {
        if ((<string>$("#keyInputField").val()).length == 4) {
          this.teacherToolService.loadTaskFromServer(
            <string>$("#keyInputField").val()
          );
        }
      });
      $("#fileInputField").change(
        function (event) {
          this.teacherToolService.openFile(event);
          swal.close();
        }.bind(this)
      );
    });

    $(".chapterButton").click(
      function (event) {
        let chapterIndex = $(event.currentTarget).data("index");
        let taskArray = exerciseData[chapterIndex];
        let taskButtons = "";
        taskArray.tasks.forEach(function (element, index) {
          taskButtons +=
            '<button data-index="' +
            index +
            '" id="' +
            element.id +
            '" class = "taskButton">' +
            exercise +
            element.id +
            "</button>";
        });
        $(".alertButtonGroup").html(taskButtons);
        $(".taskButton").click(
          function (event) {
            let index = $(event.currentTarget).data("index");
            let task = taskArray.tasks[index];
            this.gridService.openExercise(
              task,
              this.iconTurtleVariable,
              true,
              chapterIndex,
              index
            );
            this.gridService.setTitle(task.id);
            swal.close();
          }.bind(this)
        );
      }.bind(this)
    );
  }

  createExercise() {
    let modal = document.getElementById("createExerciseModal");
    modal.style.display = "block";
    (<HTMLInputElement>(
      document.getElementById("inputIdTeacherTool")
    )).placeholder = this.la.getLang()["enterTaskName"];
    let span = document.getElementsByClassName("close")[0] as HTMLElement;
    span.onclick = function () {
      modal.style.display = "none";
    };
    $(document).ready(
      function () {
        if (
          $("#wrapperClickableGridCreator").find(".boxTeacherTool").length > 0
        )
          return;
        this.teacherToolService.createBox(1, 1);
      }.bind(this)
    );

    this.teacherToolService.drawDragAndDropElements();
  }

  prepareEditor(x) {
    let file = x.files[0];
    let reader = new FileReader();
    (reader.onload = function (evt) {
      this.setEditorText(evt.target.result);
    }.bind(this)),
      false;
    reader.readAsText(file);
  }

  setEditorText(text) {
    var texts = text.split("$");
    var finalText = texts.join("\n\n");
    //delete all editors and all texts
    this.et.setTextOfCurrentEditorProgrammatically(finalText);
  }

  storeSpeedToSessionStorage() {
    this.sessionstorage.storeSpeed();
    InputComponent.updateTurtleSpeed(
      this.speedcalculator.calculateCurrentspeed()
    );
  }

  changeToSpeed(speed) {
    (<HTMLInputElement>document.getElementById("speedRange")).value = speed;
    this.storeSpeedToSessionStorage();
  }

  //Connect and disconnect a BlueBot
  async startBlueBot() {
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      swal({
        title: this.la.translateKey("disconnectBlueBot"),
        confirmButtonText: this.la.translateKey("RobotDisconnect"),
        showCancelButton: true
      }).then(value => {
        if (value) this.bluetoothService.disconnect();
      });
    } else {
      try {
        this.bluetoothService.connectBluebot();
      } catch {
        //error message if Web Bluetooth is not available
        swal({
          title: this.la.translateKey("ConnectionNotPossible"),
          text: this.la.translateKey("ConnectionError"),
          confirmButtonText: "Ok"
        });
      }
    }
  }

  async startQuickstart() {
    //create QuickstartService only if it was not created before. Otherwise reuse
    if (!this.quickstartService) {
      this.quickstartService = new QuickStartService();
    }

    if (this.blocks.isBlueBotMode()) { // QuickStarter for stage 1
      const { value: country } = await swal({
        title: this.la.translateKey("doyouneedhelp"),
        input: "select",
        inputOptions: {
          S1: "Wie verwende ich die Grundbefehle?",
          S2: "Wie setze ich ein Hintergrundbild?",
          S3: "Wie rufe ich die Aufgabensammlung auf?",
          S4: "Wie erzeuge ich meine eigenen Aufgaben?"
        },
        inputPlaceholder: this.la.translateKey("tutorialtype"),
        showCancelButton: true,
        inputValidator: value => {
          return new Promise(resolve => {
            if (value === "S1") {
              resolve();
              this.quickstartService.startGrundbefehleS1();
            } else if (value === "S2") {
              resolve();
              this.quickstartService.startHintergrundbilderS1();
            } else if (value === "S3") {
              resolve();
              this.quickstartService.startAufgabensammlungS1();
            } else if (value === "S4") {
              resolve();
              this.quickstartService.startEigeneAufgabenS1();
            } else {
              return !value && "You need to choose something!";
            }
          });
        }
      });
    }else if(this.blocks.isBlockMode()){ // QuickStarter for stage 2
      const { value: country } = await swal({
        title: this.la.translateKey("doyouneedhelp"),
        input: "select",
        inputOptions: {
          S1: "Wie verwende ich die Grundbefehle?"
        },
        inputPlaceholder: this.la.translateKey("tutorialtype"),
        showCancelButton: true,
        inputValidator: value => {
          return new Promise(resolve => {
            if (value === "S1") {
              resolve();
              this.quickstartService.startGrundbefehleS2();
            } else {
              return !value && "You need to choose something!";
            }
          });
        }
      });
    }else{ // QuickStarter for stage 3
      const { value: country } = await swal({
        title: this.la.translateKey("doyouneedhelp"),
        input: "select",
        inputOptions: {
          S1: "Wie verwende ich die Grundbefehle?",
          S2: "Wie definiere ich meine eigenen Befehle?",
          S3: "Was ist der Schrittweise-Modus?"
        },
        inputPlaceholder: this.la.translateKey("tutorialtype"),
        showCancelButton: true,
        inputValidator: value => {
          return new Promise(resolve => {
            if (value === "S1") {
              resolve();
              this.quickstartService.startGrundbefehleS3();
            } else if (value === "S2") {
              resolve();
              this.quickstartService.startModularityS3();
            } else if (value === "S3") {
              resolve();
              this.quickstartService.startSchrittweiseS3();
            }else {
              return !value && "You need to choose something!";
            }
          });
        }
      });
    }

  }

  toggleNavigation() {
    // check whether fullscreen API is allowed on browser
    if (document.fullscreenEnabled) {
      // check wheter fullscreen already toggled
      if (document.fullscreenElement) {
        // fullscreen is activated, close it
        document.exitFullscreen();
      } else {
        // fullscreen is currently deactivated, open it
        document.documentElement.requestFullscreen();
      }
    } else {
      /* IE/Edge */
      swal("Functionality is not supported.");
    }
  }

  stepBackward() {
    console.log("\n[INPT] Prev button has been clicked.");
    this.interpreterService.stepBackward();
  }

  stepForward() {
    console.log("\n[INPT] Next button has been clicked.");
    this.interpreterService.stepForward();
  }

  stopVisitorExecution() {
    this.interpreterService.stopExecution();
  }

  // hide the main dropdown menu
  untoggle() {
    let dropdowns = document.getElementsByClassName("dropdown-content");
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
  }

  // show the main dropdown menu
  toggle() {
    // on second click close (all) dropdown menus
    if (document.getElementById("myDropdown").classList.contains("show")) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById("myDropdown").classList.toggle("show");
    }
  }

  // show the turtle picture
  toggleTurtleChoice() {
    // on second click close (all) dropdown menus
    if (document.getElementById("myDropdownSpeed").classList.contains("show")) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById("myDropdownSpeed").classList.toggle("show");
    }
  }

  // how the language dropdown menu
  toggleLanguage() {
    // on second click close (all) dropdown menus
    if (
      document.getElementById("myDropdownLanguage").classList.contains("show")
    ) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById("myDropdownLanguage").classList.toggle("show");
    }
  }

  // show the mat dropdown menu
  toggleMat() {
    swal({
      title: "Hintergrundbild wählen",
      html:
        '<table style="width:100%">' +
        "<tr>" +
        '<th><img class="mat" data-id="a.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/a_tn.jpg" alt="" height=100 width=100 on></img></th>' +
        '<th><img class="mat" data-id="b.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/b_tn.jpg" alt="" height=100 width=100></img></th>' +
        '<th><img class="mat" data-id="c.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/c_tn.jpg" alt="" height=100 width=100></img></th>' +
        "</tr>" +
        "<tr>" +
        '<td><img class="mat" data-id="d.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/d_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="e.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/e_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="f.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/f_tn.jpg" alt="" height=100 width=100></img></td>' +
        "</tr>" +
        "<tr>" +
        '<td><img class="mat" data-id="g.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/g_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="h.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/h_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="i.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/i_tn.jpg" alt="" height=100 width=100></img></td>' +
        "</tr>" +
        "<tr>" +
        '<td><img class="mat" data-id="j.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/j_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="k.jpg" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/k_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img class="mat" data-id="none" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/none.png" alt="" height=100 width=100></img></td>' +
        "<td> </td>" +
        "</tr>" +
        "</table>"
    });
    $(".mat").click(
      function (event) {
        this.setMat($(event.currentTarget).data("id"));
        if (this.gridService.exerciseModeActive()) {
          this.gridService.quitExerciseMode();
          // Reset the turtle to the initial position
          this.canvasService.clearScreen();
          this.blocks.clearWorkspace();
          this.blocks.clearHistory();
          this.canvasService.drawTurtleInit();
          this.canvasService.flushCanvas();
        }
      }.bind(this)
    );
  }

  setTurtle(name: string, nameIcon?: string) {
    // draw new image
    var img = new Image();
    img.src = "app/img/turtles/" + name + ".png";
    img.addEventListener("load", CanvasComponent.turtleImgLoadFunction);
    this.canvasService.setImg(img);
    // set menu icon to nameIcon or according to name
    if (nameIcon) {
      this.iconTurtleVariable = "app/img/turtles/" + nameIcon + ".png";
    } else {
      this.iconTurtleVariable = "app/img/turtles/" + name + ".png";
    }
  }

  showfeatures() {
    //read featurelist
    var url = "../features.txt";

    var jsonFile = new XMLHttpRequest();
    jsonFile.open("GET", url, true);
    jsonFile.send();

    jsonFile.onreadystatechange = function () {
      if (jsonFile.readyState == 4 && jsonFile.status == 200) {
        swal("NEW FEATURES:", jsonFile.responseText);
      }
    };
  }

  showCheatsheet() {
    let CHEAT_SHEET_URL;

    switch (this.la.getLangAbbrev()) {
      case "de":
        CHEAT_SHEET_URL = this.CHEAT_SHEET_URL_DE;
        break;
      case "fr":
        CHEAT_SHEET_URL = this.CHEAT_SHEET_URL_FR;
        break;
      default:
        //we do not have the cheat sheet in any other language than french and german at the moment.
        //defaulting to german.
        CHEAT_SHEET_URL = this.CHEAT_SHEET_URL_DE;
    }

    if (this.blocks.isBlueBotMode()) {
      CHEAT_SHEET_URL = this.CHEAT_SHEET_URL_STAGE1_DE;
    }


    if (!isElectron()) {
      window.open(CHEAT_SHEET_URL, "_blank");
    } else {
      window.location.href = CHEAT_SHEET_URL;
    }
  }

  // change the system language to english
  setLangEn() {
    this.la.setLang(LanguageService.EnglishID);
    this.iconVariable = "app/img/countryIcons/english.png";
    this.la.space.next("english");
  }

  // change the system language to german
  setLangDe() {
    this.la.setLang(LanguageService.GermanID);
    this.iconVariable = "app/img/countryIcons/german.png";
    this.la.space.next("german");
  }

  // change the system language to italian
  setLangIt() {
    this.la.setLang(LanguageService.ItalianID);
    this.iconVariable = "app/img/countryIcons/italian.png";
    this.la.space.next("italian");
  }

  // change the system language to french
  setLangFr() {
    this.la.setLang(LanguageService.FrenchID);
    this.iconVariable = "app/img/countryIcons/french.png";
    this.la.space.next("french");
  }

  // change the system language to spanish
  setLangEs() {
    this.la.setLang(LanguageService.SpanishID);
    this.iconVariable = "app/img/countryIcons/spanish.png";
    this.la.space.next("spanish");
  }

  async loginOnline() {
    //the return value for tryLogin is null for anything except cancel
    //in case the user cancelled, we do not want to reset the screen
    //otherwise: when logout --> clear screen, editor and history
    await this.loginService.tryLogin().then(async loggedIn => {
      //user
      if (loggedIn === "login") {
        var username = this.loginService.getUser().getUsername();
        this.storageService.setSessionDirectory(username);
        this.storageService.setUserPassword(
          sha256.x2(this.loginService.getUserPassword())
        );
      } else if (loggedIn === "logout") {
        //verify whether they really want to log out
        await swal({
          title: this.la.translateKey("doYouWantToLogOut"),
          text: this.la.translateKey("didYouSaveYourPrograms"),
          type: "question",
          showCancelButton: true
        })
          .then(result => {
            if (result) {
              //logout is confirmend
              this.canvasService.cs();
              this.commandsService.deleteAll(true);
              this.commandsService.removeAllCommandFromHistory();
              CanvasComponent.canvasComponent.flush();
              this.et.setTextOfCurrentEditorProgrammatically("");
              this.storageService.setSessionDirectory("");
              this.storageService.setUserPassword("");
              this.loginService.logout();

              //set tooltip text of login button to 'Login' once the user is logged out
              document.getElementById(
                "tooltiplogin"
              ).textContent = this.la.translateKey("loginButton");
            }
          })
          .catch(error => {
            //the user pressed cancel. We have to catch it, but we do not really care. There is nothing to do in this case.
          });
      } else if (loggedIn === "cancel") {
        //Do not react since they were not logged in and cancelled
      } else {
        //Not supposed to happen
      }
    });
  }

  checkConnection() {
    //check whether network connection available
    if (!navigator.onLine) {
      swal({
        title: this.la.translateKey("noconnection"),
        type: "error"
      });
      return;
    }
  }

  setMat(name) {
    if (name === "none") {
      //set background to none
      document.getElementById("canvasD").style.background = "initial";
      this.canvasService.setSLM(1 / 1.8);
    } else if (name === "d.jpg" || name === "g.jpg") {
      //long pictures
      this.canvasService.setSLM(1 / 1.8 * 2.2);
      //CanvasComponent.STROKE_LENGTH_MULTIPLIER * 2.2;
      document.getElementById("canvasD").style.backgroundImage =
        "url('app/img/bluebotmats/" + name + "')";
      document.getElementById("canvasD").style.backgroundRepeat = "no-repeat";
      document.getElementById("canvasD").style.backgroundPosition =
        "top center";
      document.getElementById("canvasD").style.opacity = "0.6";
      document.getElementById("canvasD").style.backgroundSize = "68%";
    } else {
      //set background to picture given through parameter and set line length to factor 2.2
      this.canvasService.setSLM(1 / 1.8 * 2.2);
      document.getElementById("canvasD").style.backgroundImage =
        "url('app/img/bluebotmats/" + name + "')";
      document.getElementById("canvasD").style.backgroundRepeat = "no-repeat";
      document.getElementById("canvasD").style.backgroundPosition =
        "top center";
      document.getElementById("canvasD").style.opacity = "0.6";
      document.getElementById("canvasD").style.backgroundSize = "35%";
    }
  }

  //anonymous method for saveFile
  saveToHardDisc(text) {
    // construct fileName consisting of current date and the word Logo
    let dateObj = new Date();
    let month = dateObj.getUTCMonth() + 1;
    let day = dateObj.getUTCDate();
    let year = dateObj.getUTCFullYear();
    let currDate = day + "/" + month + "/" + year;

    //download file
    this.et.downloadFile("Logo " + currDate + ".lgo", text);
  }

  // save the editors content
  saveFile() {
    //prepare text to be stored
    let text = this.et.prepareEditorTabContentForSaving();

    //if no text: warning
    if (text === " ") {
      swal(this.la.translateKey("notingtosave"));
      return;
    }

    //prepare all information required to save information online
    if (this.loginService.isLoggedIn()) {
      //user session already present, store online directly
      this.storageService.setSessionDirectory(
        this.loginService.getUser().getUsername()
      );
      this.storageService.setUserPassword(
        sha256.x2(this.loginService.getUserPassword())
      );

      //if document bigger than 5KB --> reject in client (same on server)
      if (text.length > 5000) {
        swal({
          title: this.la.translateKey("toomuchtext"),
          text: this.la.translateKey("toomuchtexthint"),
          type: "error"
        });
        return;
      }
    }
    // show option to save locally or at pinboard
    swal({
      title: this.la.translateKey("howtosave"),
      text: this.la.translateKey("save"),
      showCancelButton: true,
      confirmButtonText: this.la.translateKey("locally"),
      cancelButtonText: this.la.translateKey("online"),
      imageUrl: "app/img/navigation/save.png"
    })
      .then(result => {
        // Disk was chosen
        if (result) {
          this.saveToHardDisc(text);
        }
      })
      .catch(async error => {
        //online option was chosen (i.e., clicked on swal's "cancel" button, which we re-purposed for our needs. Hence we're in the catch clause)
        if (error === "cancel") {
          this.checkConnection();

          //if document bigger than 5KB --> reject in client (same on server)
          if (text.length > 5000) {
            swal({
              title: this.la.translateKey("toomuchtext"),
              text: this.la.translateKey("toomuchtexthint"),
              type: "error"
            });
            return;
          }

          // Online storage was chosen but user is not logged in yet
          if (!this.loginService.isLoggedIn()) {
            //user is not logged in... require credentials
            await this.loginService
              .tryLogin()
              .then(async loggedIn => {
                if (loggedIn === "login") {
                  //if logged in after demanding to log in
                  //--> save content
                  this.storageService.setSessionDirectory(
                    this.loginService.getUser().getUsername()
                  );
                  this.storageService.setUserPassword(
                    sha256.x2(this.loginService.getUserPassword())
                  );
                  this.storageService.saveOnline(text);
                }
              })
              .catch(error => {
                //do nothing. This is to catch errors when "cancel" pressed. Swal usually issues an error whenever cancel was pressed...
              });
          } else {
            // Online storage was chosen and user is logged in --> Save the file online
            this.storageService.saveOnline(text);
          }
        } else {
          //overlay, don't do anything
        }
      });
  }

  prepareLoadFile(x) {
    // show option to save locally or at pinboard (online)
    if (this.loginService.isLoggedIn()) {
      //user is already logged in --> make sure all required info for online loading is available
      this.storageService.setSessionDirectory(
        this.loginService.getUser().getUsername()
      );
      this.storageService.setUserPassword(
        sha256.x2(this.loginService.getUserPassword())
      );
    }
    //ask user whether to load file from disk or online
    swal({
      title: this.la.translateKey("load"),
      showCancelButton: true,
      confirmButtonText: this.la.translateKey("locally"),
      cancelButtonText: this.la.translateKey("online"),
      imageUrl: "app/img/navigation/save.png"
    })
      .then(result => {
        // Disk was chosen
        if (result) {
          //load from hard disc
          x.value = null;
          x.setAttribute("type", "file");
          x.setAttribute("accept", ".lgo");
          x.click();
        }
      })
      .catch(async error => {
        if (error === "cancel") {
          this.checkConnection();

          // Online storage was chosen
          if (!this.loginService.isLoggedIn()) {
            //user is not logged in... require credentials
            await this.loginService
              .tryLogin()
              .then(async loggedIn => {
                if (loggedIn === "login") {
                  //if logged in after demanding to log in
                  //--> load user directory online
                  this.storageService.setSessionDirectory(
                    this.loginService.getUser().getUsername()
                  );
                  this.storageService.setUserPassword(
                    sha256.x2(this.loginService.getUserPassword())
                  );
                  this.storageService.loadFilesOnline();
                }
              })
              .catch(error => {
                //do nothing
              });
          } else {
            this.storageService.loadFilesOnline();
          }
        } else {
          //overlay, don't do anything
        }
      });
  }

  public startExamMode(): void {
    if (!this.loginService.isLoggedIn()) {
      swal({
        type: "error",
        title: this.la.translateKey("notauthorizedTitle"),
        text: this.la.translateKey("notauthorizedText")
      });
      return;
    }

    this.examService.turnOnExamMode();

    //switch to full screen
    if ((<any>document).documentElement.requestFullScreen) {
      (<any>document).documentElement.requestFullScreen();
    } else if ((<any>document).documentElement.mozRequestFullScreen) {
      (<any>document).documentElement.mozRequestFullScreen();
    }
  }

  showAvailableRobots() {
    //if it is in blocks mode 1, both robots are available
    if (this.blocks.isBlueBotMode()) {
      swal({
        title: this.la.translateKey("WhichRobotUsed"),
        html:
          '<table style="width:100%">' +
          "<tr>" +
          '<th><img src="app/img/robots/bluebot.jpg" alt="" height=150 width=150 on></img></th>' +
          '<th><img src="app/img/robots/root.jpg" alt="" height=150 width=150></img></th>' +
          "</tr>" +
          "</table>",
        showCancelButton: true,
        cancelButtonText: "Root",
        confirmButtonText: "BlueBot",
        confirmButtonColor: "#00b300",
        cancelButtonColor: "#00b300"
      })
        .then(value => {
          if (value) {
            this.startBlueBot();
          }
        })
        .catch(value => {
          // make sure we didn't end up here because the user clicked outside the box somewhere to cancel
          // note: e "misuse" the cancel button here, so the value will be "cancel" since the user clicked the cancel button
          if (value != "overlay") {
            this.rootRobot();
          }
        });
    } else {
      //in version 2 and 3 only root is available, but not bluebot
      swal({
        title: this.la.translateKey("WhichRobotUsed"),
        html:
          '<table style="width:100%">' +
          "<tr>" +
          '<th><img src="app/img/robots/bluebotinactiv.jpg" alt="" height=150 width=150 on></img></th>' +
          '<th><img src="app/img/robots/root.jpg" alt="" height=150 width=150></img></th>' +
          "</tr>" +
          "</table>",
        showCancelButton: true,
        cancelButtonText: "Root",
        confirmButtonText: "BlueBot",
        confirmButtonColor: "#bbbbbb",
        cancelButtonColor: "#00b300"
      })
        .then(value => {
          if (value) {
            this.showAvailableRobots();
          }
        })
        .catch(value => {
          // make sure we didn't end up here because the user clicked outside the box somewhere to cancel
          // note: e "misuse" the cancel button here, so the value will be "cancel" since the user clicked the cancel button
          if (value != "overlay") {
            this.rootRobot();
          }
        });
    }
  }

  async rootRobot() {
    //same as startBlueBot
    if (this.rootService.isConnected()) {
      swal({
        title: this.la.translateKey("RobotConnected"),
        confirmButtonText: this.la.translateKey("RobotDisconnect"),
        showCancelButton: true
      }).then(value => {
        if (value) {
          this.rootService.disconnect();
        }
      });
    } else {
      try {
        this.rootService.connect();
        // when we are in the blocks environment, we use "setpc white" identical as "pu"
        // in the following case distinction we identify whether the robot sould perform a
        // "penup" operation whenever it encounters the command "setpc white". This is only
        // done in the two blocks versions (since they do not have an explicit command for "pu")
        if (this.blocks.isBlockMode()) {
          this.rootService.setBlocks(true);
        } else {
          this.rootService.setBlocks(false);
        }
      } catch (error) {
        console.log("Something went wrong. " + error);

        //error message if Web Bluetooth is not available
        swal({
          title: this.la.translateKey("ConnectionNotPossible"),
          text: this.la.translateKey("ConnectionError"),
          confirmButtonText: "Ok"
        });
      }
    }
  }
}
// vim: shiftwidth=2



// WEBPACK FOOTER //
// ./src/app/components/header.component.ts